<template>
  <keep-alive>
    <component
      class="modal-content"
      :is="component"
      v-bind="componentProps[true]"
      @input="$emit('input', $event)"
      @source-type="$emit('source-type', $event)"
      @attestation-check="$emit('attestation-check', $event)"
      v-on="$listeners"
    />
  </keep-alive>
</template>

<script>
import DeliveryStep from '@/components/schedulerModal/schedulerSteps/DeliveryStep.vue'
import FormatStep from '@/components/schedulerModal/schedulerSteps/FormatStep.vue'
import ParametersStep from '@/components/schedulerModal/schedulerSteps/ParametersStep.vue'
import SourceStep from '@/components/schedulerModal/schedulerSteps/SourceStep'
import { COMPONENT_STEPS } from '@/components/schedulerModal/config/constants'

export default {
  name: 'SchedulerModalContent',
  components: {
    DeliveryStep,
    FormatStep,
    ParametersStep,
    SourceStep,
  },
  props: {
    sourceStepInfo: {
      type: Object,
      default: /* istanbul ignore next */ () => ({}),
    },
    parametersStepInfo: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
    formatStepInfo: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
    deliveryStepInfo: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
    sourceType: {
      type: String,
      default: '',
    },
    dataSetType: {
      type: String,
      default: '',
    },
    investmentId: {
      type: String,
      default: '',
    },
    stepperId: {
      type: Number,
      default: 0,
    },
    holdingsEntitlements: {
      type: Object,
      default: /* istanbul ignore next */ () => ({}),
    },
    withoutFeedName: Boolean,
  },
  computed: {
    component() {
      return COMPONENT_STEPS[this.stepperId] || ''
    },
    componentProps() {
      return {
        [this.component === COMPONENT_STEPS[0]]: {
          sourceStepInfo: this.sourceStepInfo,
          sourceType: this.sourceType,
          dataSetType: this.dataSetType,
        },
        [this.component === COMPONENT_STEPS[1]]: {
          parametersStepInfo: this.parametersStepInfo,
          sourceType: this.sourceType,
          investmentId: this.investmentId,
          dataSetType: this.dataSetType,
        },
        [this.component === COMPONENT_STEPS[2]]: {
          formatStepInfo: this.formatStepInfo,
          sourceType: this.sourceType,
          dataSetType: this.dataSetType,
        },
        [this.component === COMPONENT_STEPS[3]]: {
          withoutFeedName: this.withoutFeedName,
          deliveryStepInfo: this.deliveryStepInfo,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.modal-content {
  display: flex;
  flex-direction: column;
  flex: auto;
  :first-child {
    margin-bottom: $mds-space-1-x;
    &::v-deep > [class^='mds-label__text'] {
      margin-bottom: $mds-space-1-x;
    }
  }
}
</style>
